<div class="sz-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u">
    <div class="n-szuro-sor">
      <div class="sz-valto">
        <a [class.aktiv]="nezet === 'rendezetlen'" (click)="nezet = 'rendezetlen'">Rendezetlen tételek</a>
        <a [class.aktiv]="nezet === 'kiegyenlitesek'" (click)="nezet = 'kiegyenlitesek'">Kiegyenlítések</a>
      </div>
      <ng-container *ngIf="nezet === 'rendezetlen'">
        <label><input type="checkbox" [(ngModel)]="csakLejart"> csak lejárt</label>
        <span class="spacer"></span>
        <span class="halvany">Hátralék: <b>{{ szam(hatralek) }} Ft</b> · ebből lejárt: <b class="neg">{{ szam(lejartOssz) }} Ft</b></span>
      </ng-container>
      <ng-container *ngIf="nezet === 'kiegyenlitesek'">
        <label>Tól <input type="date" [(ngModel)]="tol" (change)="frissit()"></label>
        <label>Ig <input type="date" [(ngModel)]="ig" (change)="frissit()"></label>
        <span class="spacer"></span><span class="halvany">Befizetve: <b>{{ szam(befizetve) }} Ft</b></span>
      </ng-container>
    </div>
    <div class="tabla-wrap" *ngIf="nezet === 'rendezetlen'">
      <table class="n-racs sz-racs">
        <thead><tr><th>Számla</th><th>Vevő</th><th>Kelt</th><th>Határidő</th><th class="num">Bruttó</th><th class="num">Fizetve</th><th class="num">Hátralék</th><th class="num">Késés (nap)</th></tr></thead>
        <tbody>
          <tr *ngFor="let x of lathato" class="kattinthato" (click)="pdf(x)">
            <td><b>{{ x.szamlaszam }}</b></td><td>{{ x.vevo_nev }}</td><td>{{ x.kelt }}</td><td [class.neg]="x.kesedelem > 0">{{ x.fizhat }}</td>
            <td class="num">{{ szam(x.brutto) }}</td><td class="num">{{ szam(x.fizetve) }}</td><td class="num sz-osszeg">{{ szam(x.hatralek) }}</td>
            <td class="num" [class.neg]="x.kesedelem > 0">{{ x.kesedelem || '' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="sz-ures" *ngIf="!lathato.length">Nincs rendezetlen számla.</div>
    </div>
    <div class="tabla-wrap" *ngIf="nezet === 'kiegyenlitesek'">
      <table class="n-racs sz-racs">
        <thead><tr><th>Dátum</th><th>Bizonylat</th><th>Vevő</th><th>Mód</th><th>Megjegyzés</th><th class="num">Összeg</th></tr></thead>
        <tbody>
          <tr *ngFor="let x of kiegy" class="kattinthato" (click)="pdf(x)">
            <td>{{ x.datum }}</td><td><b>{{ x.szamlaszam }}</b></td><td>{{ x.vevo_nev }}</td><td>{{ x.fizmod }}</td><td>{{ x.megjegyzes }}</td><td class="num sz-osszeg">{{ szam(x.osszeg) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="sz-ures" *ngIf="!kiegy.length">Az időszakban nem volt befizetés.</div>
    </div>
  </ng-container>
</div>
